export default function ActivityLogCardIcon({ size = 80 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0C5.37258 0 0 5.37258 0 12V68C0 74.6274 5.37258 80 12 80H68C74.6274 80 80 74.6274 80 68V12C80 5.37258 74.6274 0 68 0H12ZM10 12C10 10.8954 10.8954 10 12 10H68C69.1046 10 70 10.8954 70 12V68C70 69.1046 69.1046 70 68 70H12C10.8954 70 10 69.1046 10 68V12ZM20 22H60V30H20V22ZM20 36H52V44H20V36ZM20 50H44V58H20V50Z"
        fill="#3B3B3B"
        fillOpacity="0.3"
      />
    </svg>
  );
}
